import Backdrop from "components/global/Backdrop";
import styled from "styled-components";
import plusIcon from "assets/icons/plus.svg";
import Button from "components/global/Button";
import ModalWrapper from "components/global/ModalWrapper";
import DropdownCustom from "components/global/DropdownCustom";
import { useEffect } from "react";
import { getUserCards } from "api";
import mastercard from "assets/images/mastercard.png";
import visacard from "assets/images/visacard.png";
import { connect } from "react-redux";
import DebitCardIcon from "icons/DebitCardIcon";

const Wrapper = styled(Backdrop)`
  padding: 0;

  .select_payment_card_modal {
    width: 480px;
    padding: 48px;
    border-radius: 16px;
    background-color: #fff;
    gap: 24px;

    &__modal_header {
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: center;

      header {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
      }

      .description {
        color: var(--body_text);
        font-size: 14px;
        font-weight: 450;
        line-height: 20px;
      }
    }

    &__add_btn {
      width: 100%;
      height: 48px;
      gap: 8px;
      border: 1px solid var(--grey_10);
      background: var(--background);
      border-radius: 8px;

      &:hover {
        background-color: inherit;
        color: var(--grey_1);
      }
    }

    &__btn_row {
      gap: 24px;
    }

    &__select_card {
      button {
        &:hover {
          color: var(--grey_1);
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .select_payment_card_modal {
      width: calc(100% - 24px);
      padding: 24px;
    }
  }
`;

const DropdownComponent = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;

  .card_type {
    width: 32px;
    height: 24px;
    img {
      object-fit: contain;
    }
  }

  &:hover {
    color: var(--grey_1);
  }
`;

const renderDropdownComponent = (card) => {
  return (
    <DropdownComponent>
      <div className="card_type">
        {card.card_type.toLowerCase().replace(/^\s+|\s+$/g, "") === "visa" && (
          <img src={visacard} alt="card" width="100%" height="100%" />
        )}
        {card.card_type.toLowerCase().replace(/^\s+|\s+$/g, "") ===
          "mastercard" && (
          <img src={mastercard} alt="card" width="100%" height="100%" />
        )}
        {!["mastercard", "visa"].includes(
          card.card_type.toLowerCase().replace(/^\s+|\s+$/g, "")
        ) && <DebitCardIcon />}
      </div>
      <div className="card_number">**** {card?.last_4}</div>
    </DropdownComponent>
  );
};

const BillingCardSelect = ({
  handlePayment,
  selectedCard,
  setSelectedCard,
  showModal,
  closeModal,
  submitting,
  user_cards,
  handleAddPaymentMethod,
}) => {

  useEffect(() => {
    const defaultCard = user_cards?.find((item) => item.is_default === true);
    setSelectedCard(defaultCard ?? user_cards[0]);
    // eslint-disable-next-line
  }, [user_cards]);

  useEffect(() => {
    getUserCards();
    // eslint-disable-next-line
  }, []);

  return (
    <Wrapper className={`flexRow justifyEnd${showModal ? " show" : ""}`}>
      <ModalWrapper>
        <div className="select_payment_card_modal flexColumn">
          <div className="select_payment_card_modal__modal_header">
            <header>Select payment method</header>
            <p className="description">
              Choose a payment method to complete your transaction.
            </p>
          </div>

          <DropdownCustom
            className="select_payment_card_modal__select_card"
            name="selected-card"
            list={user_cards}
            value={selectedCard}
            setValue={setSelectedCard}
            renderContent={renderDropdownComponent}
          />

          <button
            className="select_payment_card_modal__add_btn flexRow alignCenter justifyCenter"
            onClick={handleAddPaymentMethod}
            disabled={submitting}
          >
            <img src={plusIcon} alt="add" width="16px" height="16px" /> Add
            payment method
          </button>

          <div className="select_payment_card_modal__btn_row flexRow">
            <Button
              text="Cancel"
              fullWidth
              height="48px"
              className="borderedGrey"
              onClick={closeModal}
              disabled={submitting}
            />
            <Button
              text="Proceed to pay"
              fullWidth
              height="48px"
              disabled={!selectedCard}
              onClick={handlePayment}
              loading={submitting}
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user_cards: state.debit_cards,
  };
};

export default connect(mapStateToProps)(BillingCardSelect);
